import { useQuery } from "@tanstack/react-query";
import { api } from "./api.ts";
import { useSession } from "./auth.ts";

// Active org's channel type (reseller|customer). The Better-Auth org plugin doesn't
// serialize our custom `type` column, so it's fetched from the dedicated
// GET /v1/orgs/:orgId endpoint and cached for the session. Gates the reseller-portal
// nav link + page (COMMISSIONING_WARRANTY.md P5). Mirrors useStaff().
export function useOrg() {
  const { data: session, isPending: sessionPending } = useSession();
  const orgId = session?.session.activeOrganizationId;
  const enabled = !!orgId && !sessionPending;
  const q = useQuery({
    queryKey: ["org", orgId, "info"],
    queryFn: () => api.orgInfo(orgId!),
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
  });
  return {
    isPending:  sessionPending || (enabled && q.isPending),
    type:       q.data?.type ?? null,
    name:       q.data?.name ?? null,
    isReseller: q.data?.type === "reseller",
  };
}
